export default [
    '$provide',
    function getDirectiveTemplateUrlDecorator($provide) {
        $provide.decorator('$rootScope', [
            '$delegate',
            'spAppData',
            function decorate($delegate, spAppData) {
                var staticUrl = spAppData.get('urls').static;

                $delegate.getDirectiveTemplateUrl = function getDirectiveTemplateUrl(module, name) {
                    return staticUrl + '/' + module + '/templates/directives/' + name + '.nghtml';
                };

                return $delegate;
            }
        ]);
    }
];
